<template>
  <div class="glo_Table">
    <el-table
      :height="Config.maxHeight"
      header-align="center"
      ref="mytable"
      :data="Config.tableData"
      border
      stripe
      :highlight-current-row="true"
      @selection-change="Change"
    >
      <el-table-column
        fixed="left"
        align="center"
        label="序号"
        type="index"
        width="60"
      >
      </el-table-column>

      <template v-for="(item, index) in Heads">
        <template v-if="item.field !== 'edit'">
          <el-table-column
            v-if="!item.hasButton"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :sortable="item.isSort || false"
            :show-overflow-tooltip="true"
            :min-width="item.width || 120"
            :data-isTotal="item.isTotal || false"
          />
          <template v-else>
            <el-table-column
              :label="item.name"
              :min-width="item.width || 120"
              align="center"
              :key="index"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click.stop="Callback(scope.row, item.method)"
                  :disabled="
                    scope.row.fileIds == null || scope.row.fileIds == ''
                  "
                >
                  {{ item.methodName }}
                </el-button>
              </template>
            </el-table-column>
          </template>
        </template>
        <template v-else>
          <el-table-column
            fixed="right"
            :min-width="item.width || 120"
            :label="item.name"
            :key="index"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click.stop="Callback(scope.row, item.method)"
                :disabled="
                  scope.row.operationType == 'fan_he_xiao:writeoff_type'
                "
              >
                {{ item.methodName }}
              </el-button>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
  </div>
</template>
<script >
export default {
  components: {},
  props: {
    tableConfig: {
      type: Object,
    },
    tableHeads: {
      type: Array,
    },
  },
  emits: ["selectChange", "rowCallback"],
  data() {
    return {
      Config: this.tableConfig,
      Heads: this.tableHeads,
    };
  },
  methods: {
    Change(e) {
      this.$emit("selectChange", e);
    },
    Callback(e, opt) {
      this.$emit("rowCallback", e, opt);
    },
  },
};
</script>
<style scoped lang="less">
.glo_Table {
  height: 55vh;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 7px;
}
</style>
